export var QueryParams;
(function (QueryParams) {
    QueryParams["PRESELECTED_DEALER_ID"] = "preselectedDealerId";
    QueryParams["HASHED_CART_ID"] = "hashedCartId";
    QueryParams["CART_ID"] = "cartId";
})(QueryParams || (QueryParams = {}));
export const INTERSECTION_THRESHOLD = 0.2;
export const cartEmpty = 'cartEmpty';
